import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';

import {
  postMessage,
  type PostMessageParams,
  type PostMessageResponse,
} from '@services/MatchesService';

export type UsePostMessageParams = {
  mutationOptions?: SWRMutationConfiguration<
    PostMessageResponse,
    unknown,
    string,
    PostMessageParams,
    PostMessageResponse
  >;
};

export const postMessageMutationKey = 'post-message';

export const usePostMessage = ({
  mutationOptions,
}: UsePostMessageParams = {}) => {
  const { trigger, ...swrResponse } = useSWRMutation<
    PostMessageResponse,
    unknown,
    string,
    PostMessageParams
  >(
    postMessageMutationKey,
    (_url, { arg }) => postMessage(arg),
    mutationOptions,
  );

  return {
    trigger,
    ...swrResponse,
  };
};
